// Tiny DOM helpers shared by every tool module.
export const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
export const btn = (label, fn, cls) => { const b = el("button", cls || "rv-tbtn", label); b.type = "button"; if (fn) b.addEventListener("click", fn); return b; };
export const input = (type, attrs) => { const i = el("input", "rv-tinput"); i.type = type || "text"; if (attrs) Object.assign(i, attrs); return i; };
export const ta = (attrs) => { const t = el("textarea", "rv-tarea"); if (attrs) Object.assign(t, attrs); return t; };
export const sel = (options, value) => { const s = el("select", "rv-tselect"); options.forEach(([v, l]) => { const o = el("option", null, l); o.value = v; s.appendChild(o); }); if (value != null) s.value = value; return s; };
export const row = (...kids) => { const r = el("div", "rv-trow"); r.append(...kids.filter(Boolean)); return r; };
export const col = (...kids) => { const r = el("div", "rv-tcol"); r.append(...kids.filter(Boolean)); return r; };
export const field = (labelText, control) => { const w = el("label", "rv-field"); w.append(el("span", "rv-field-label", labelText), control); return w; };
export const note = (text) => el("p", "rv-tnote", text);
// "Not saved" next to an editor. set(ok) takes writeJSON's answer: shown on false, hidden on true.
export function saveFlag() {
	const f = el("p", "rv-not-saved", "Not saved: this browser is out of space for Re:Vault.");
	f.setAttribute("role", "status");
	f.hidden = true;
	f.set = (ok) => { f.hidden = ok !== false; return ok; };
	return f;
}

// Reset the tool root and return a fresh <section> to render into.
export function wrap(root) { root.textContent = ""; const s = el("section", "rv-tool"); root.appendChild(s); return s; }

// Copies text. The clipboard API is missing on http and in older Safari, and a school policy or
// Safari outside a tap can refuse it, so it falls back to a hidden field and execCommand. 16px,
// so focusing it does not zoom an iPhone. Resolves true when it copied.
export function copy(text, doc = document, nav = navigator) {
	text = String(text);
	const byHand = () => {
		let t = null;
		try {
			t = doc.createElement("textarea");
			t.value = text;
			t.setAttribute("readonly", "");
			t.style.cssText = "position:fixed;top:0;left:0;opacity:0;font-size:16px";
			doc.body.appendChild(t);
			t.select();
			t.setSelectionRange(0, text.length);
			return doc.execCommand("copy") === true;
		} catch { return false; } finally { if (t) t.remove(); }
	};
	const c = nav && nav.clipboard;
	if (c && c.writeText) { try { return c.writeText(text).then(() => true, byHand); } catch { /* fall through */ } }
	return Promise.resolve(byHand());
}
export function download(name, dataUrl) { const a = el("a"); a.href = dataUrl; a.download = name; document.body.appendChild(a); a.click(); a.remove(); }
export function beep(ms, freq) {
	try {
		const ctx = new (window.AudioContext || window.webkitAudioContext)();
		const o = ctx.createOscillator(), g = ctx.createGain();
		o.frequency.value = freq || 880; o.connect(g); g.connect(ctx.destination);
		o.start(); g.gain.setValueAtTime(0.2, ctx.currentTime);
		g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + (ms || 400) / 1000);
		o.stop(ctx.currentTime + (ms || 400) / 1000);
	} catch (e) {}
}

// One polite live region per page, shared by every tool. It is created empty and the text goes in
// on the next frame, so screen readers notice the change.
let live = null;
function makeLive() {
	live = el("div", "rv-sr-only");
	live.setAttribute("role", "status");
	live.setAttribute("aria-live", "polite");
	document.body.appendChild(live);
}
// Made up front: a live region added at the same moment as its first message is often not read.
if (typeof document !== "undefined" && document.body) makeLive();
export function announce(text) {
	if (!live) makeLive();
	live.textContent = "";
	requestAnimationFrame(() => { live.textContent = text; });
}
// Mode chips: the chosen one gets aria-pressed so the choice isn't shown by colour alone.
export function markPressed(buttons, chosen) { buttons.forEach((b) => b.setAttribute("aria-pressed", b === chosen ? "true" : "false")); }
// The same, but only once input settles (for results that change on every keystroke).
let soonTimer = 0;
export function announceSoon(text, ms = 800) { clearTimeout(soonTimer); soonTimer = setTimeout(() => announce(text), ms); }
